<template>
  <div class="d-flex flex-row flex-wrap" :style="`column-gap: ${gapInPx}px; row-gap: 8px`">
    <template v-if="!!content">
      <form-node
        v-for="(item, i) in content"
        :key="i"
        v-bind="item"
        v-on="$listeners"
        :class="`d-flex flex-grow-${grow} w-children-full`"
      />
    </template>
    <slot v-else />
  </div>
</template>

<script>
import { PropsDefinition, Computed } from '@/_typedefs'
import { FormNodeProps } from '../FormNode.vue'

/**
 * @typedef {Object} RowNodeProps
 * @property {number} gap
 * @property {FormNodeProps[]} content
 */

export default {
  name: 'RowNode',
  /** @type {PropsDefinition<RowNodeProps>} */
  props: {
    gap: {
      type: Number,
      default: 4,
    },
    grow: {
      type: Number,
      default: 1,
    },
    content: {
      type: Array,
      default: null,
    },
  },
  computed: {
    /** @type {Computed<number>} */
    gapInPx() {
      return this.gap * 4
    },
  },
}
</script>

<style scoped>
.w-children-full > :deep(div) {
  width: 100%;
}
</style>
